export enum ComponentTypes {
    text = "Text",
    input = "Input",
    dateInput = "DateInput",
    select = "Select",
    inputWithSelect = "InputWithSelect",
    money = "Money",
    checkbox = "Checkbox",
    radio = "Radio",
    multiline = "Multiline",
    table = "Table",
    file = "Subtemplate",
    hrPerson = "HrPersons",
    yandex = "Yandex",
    legalYandex = "LegalYandex",
    counterparty = "VendorData",
    saveAndTicket = "SaveAndTicket",
    saveToExistingTicket = "StartrekAttachDoc",
    pdfPassword = "PdfUserPassword",
    trackerIntegration = "StartrekIntegration",
    iprocIntegration = "IprocIntegration",
    externalForm = "Ext",
    language = "Lang",
    uuid = "Uuid",
    barcode = "Barcode",
    autonumber = "Autonumber",
    preview = "Preview",
    massDocGeneration = "MassDocGeneration"

}
